<script>
    export let black=true;
</script>
<h3 class="text-3xl md:text-3xl lg:text-4xl {black?'text-gray-800':'text-white'} p-3 font-Display">
    <slot></slot>
</h3>